
export default {
  computed: {
    locais() {
      return [
        {
          icon: "mdi-pound",
          text: this.id,
          title: "ID",
        },
        {
          icon: "mdi-briefcase-account-outline",
          text: this.plano,
          title: "Plano",
        },
        {
          icon: "mdi-account",
          text: this.nome,
          title: "Nome",
        },
        {
          icon: "mdi-account-tie",
          text: this.profissao,
          title: "Profissão",
        },
        {
          icon:
            this.sexo == "masculino" ? "mdi-gender-male" : "mdi-gender-female",
          text: this.sexo,
          title: "Sexo",
        },
        {
          icon: "mdi-card",
          text: this.cpf,
          title: "CPF",
        },
        {
          icon: "mdi-card",
          text: this.rg,
          title: "Identidade",
        },
        {
          icon: "mdi-cake",
          text: this.nascimento,
          title: "Nascimento",
        },
        {
          icon: "mdi-tooth",
          text: this.planoDental == 1 ? "Sim" : "Não",
          title: "Plano Odontológico",
        },
      ];
    },
  },
  props: {
    id: Number,
    plano: String,
    nome: String,
    profissao: String,
    sexo: String,
    cpf: String,
    rg: String,
    nascimento: String,
    planoDental: Number,
  },
};
